import { InjectionKey, Ref } from '@vue/composition-api';
import { FlowSlots, WorkFlowStore } from '../types';

export const WorkFlow: InjectionKey<WorkFlowStore> = Symbol('workFlow');
export const NodeId: InjectionKey<string> = Symbol('nodeId');
export const NodeRef: InjectionKey<Ref<HTMLDivElement | null>> = Symbol(
  'nodeRef'
);
export const EdgeId: InjectionKey<string> = Symbol('edgeId');
export const EdgeRef: InjectionKey<Ref<SVGElement | null>> = Symbol('edgeRef');
export const Slots: InjectionKey<Readonly<FlowSlots>> = Symbol('slots');
